import { render, staticRenderFns } from "./transactions-list.vue?vue&type=template&id=2e4e7618&"
import script from "./transactions-list.vue?vue&type=script&lang=js&"
export * from "./transactions-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports